import Currency from '@/constructs/Currency';
import { isNumericString } from '@/utils/string-utils';
import { ZodType, z } from 'zod';
import IMoney from './IMoney';

/** A schema representing the IMoney. */
export const MoneySchema = z.object({
  amount: z.string().refine(isNumericString, 'Amount must be a numeric string'),
  currency: z.nativeEnum(Currency)
}) as ZodType<IMoney>;
